import React, { useCallback, useEffect, useState } from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import ColumnTable from "./embrillTable/ColumnTable";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchAsyncGetVendor } from "redux/vendorSlice";
import { AiFillDelete, AiFillEye } from "react-icons/ai";
import { fetchAsyncDeleteVendor } from "redux/vendorSlice";
import VendorsAddNew from "components/allForm/Vendors/vendorsAddNew";
import { RiBankCardFill } from "react-icons/ri";
import { FaPlus } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { vendorDataColumns } from "./embrillTable/variables/vendor";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import orgJson from "components/jsonData/orgnization.json";
import useSearch from "hooks/useSearch";
import { BiExport } from "react-icons/bi";
import { fetchAsyncExportVendor } from "redux/vendorSlice";
import ExcelJS from "exceljs";
import { GstTreatment } from "components/allForm/Vendors/customFieldData";
import { accountTypeOptions } from "components/allForm/PurchaseItem/selectedOptions";
import moment from "moment";

import { GetCountries } from "utiils/countryStateCity";
import { GetState } from "utiils/countryStateCity";
import { GetCity } from "utiils/countryStateCity";
const EmbrillVendor = () => {
  const dispatch = useDispatch();
  const [vendorListData, setVendorListData] = useState([]);
  const currUser = useSelector((state) => state.auth.currUser);
  const [role, setRole] = useState("");
  const { searchText } = useSelector((state) => state.searchValue);
  const { performSearch } = useSearch();

  useEffect(() => {
    if (currUser && currUser?.auth) {
      const auth = currUser?.auth;
      const roleObj =
        auth &&
        auth?.length > 0 &&
        auth.find((item) => item?.module === "Vendor");
      if (roleObj) {
        setRole(roleObj?.access);
      }
    }
  }, [currUser]);

  const [openVendorModal, setOpenVendorModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [vendorEditData, setVendorEditData] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpenVendorModal = () => {
    setOpenVendorModal(true);
  };

  const handleCloseVendorModal = () => {
    setOpenVendorModal(false);
    setOpenEditModal(false);
    setVendorEditData(null);
    handlerRefreshData();
  };

  const handlerRefreshData = useCallback(() => {
    performSearch(searchText);
  }, [searchText, performSearch]);

  const vendorList = useSelector((state) => state.vendorData);

  const deleteVendor = (data) => {
    dispatch(fetchAsyncDeleteVendor(data._id)).then(() => {
      handlerRefreshData();
    });
  };

  const downloadClientExportGrouped = async (vendorData) => {
    const data = vendorData.data;
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "Your App";
    workbook.created = new Date();

    const worksheet = workbook.addWorksheet("Vendors", {
      properties: {
        defaultRowHeight: 22,
      },
      views: [
        {
          state: "frozen",
          ySplit: 1,
        },
      ],
    });

    worksheet.columns = [
      { header: "Sr. No.", key: "srNo", width: 10 },

      { header: "Customer Type", key: "customerType", width: 18 },
      { header: "Company Name", key: "companyName", width: 18 },

      { header: "Vendor Type", key: "vendorType", width: 18 },
      { header: "Contact Person", key: "contactPerson", width: 25 },
      { header: "Contact Email", key: "contactEmail", width: 30 },
      { header: "Contact Phone", key: "contactPhone", width: 20 },
      { header: "Mobile Number", key: "mobileNum", width: 20 },

      { header: "Tax Registration Type", key: "taxType", width: 22 },
      { header: "Tax Preference", key: "taxPreference", width: 18 },
      { header: "Opening Balance", key: "openingBalance", width: 18 },
      { header: "PAN", key: "pnNo", width: 18 },

      { header: "GST/VAT/Tax ID", key: "gst", width: 22 },
      { header: "Place Of Supply", key: "pos", width: 22 },

      { header: "Address Line 1", key: "addr1", width: 28 },
      { header: "Address Line 2", key: "addr2", width: 28 },
      { header: "Attention", key: "attention", width: 22 },
      { header: "Country", key: "addrCountry", width: 18 },
      { header: "State", key: "addrState", width: 18 },
      { header: "Town/City", key: "addrCity", width: 18 },
      { header: "Pincode", key: "addrPin", width: 15 },
      { header: "Address Type", key: "addrType", width: 18 },
      { header: "Phone", key: "addr_phone", width: 18 },
      { header: "Email", key: "addr_email", width: 28 },

      { header: "Account Holder", key: "holder", width: 25 },
      { header: "Bank Name", key: "bank", width: 25 },
      { header: "Account Number", key: "account", width: 22 },
      { header: "Account Type", key: "accountType", width: 18 },
      { header: "IFSC", key: "ifsc", width: 18 },
      { header: "Branch", key: "branch", width: 25 },
      { header: "SWIFT", key: "swift", width: 18 },
      { header: "City", key: "bnk_city", width: 18 },
      { header: "State", key: "bnk_state", width: 18 },
    ];

    const mergeColumns = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
    ];

    const numericColumns = [
      "F", // Phone
      "G", // Opening Balance
      "J", // Pincode
    ];

    const getDropdownLabel = (option, fldName) => {
      switch (fldName) {
        case "taxType": {
          const opt = GstTreatment.find((opt) => opt.id === option);
          return opt?.label;
        }
        case "accountType": {
          const opt = accountTypeOptions.find((opt) => opt.id === option);
          return opt?.label;
        }
        default:
          return option;
      }
    };

    // ---------------- Header Style ----------------

    const headerRow = worksheet.getRow(1);
    headerRow.height = 26;

    headerRow.eachCell((cell) => {
      cell.font = {
        bold: true,
        color: { argb: "FFFFFFFF" },
        size: 11,
      };

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "1F4E78" },
      };

      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };

      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" },
      };
    });
    let serialNo = 1;
    let currentRow = 2;

    for (const client of data) {
      const banks = client.bankDetails || [];
      const addresses = client.address || [];
      const gsts = client.gstDetails || [];

      const country = await GetCountries();

      const span = Math.max(banks.length, addresses.length, gsts.length, 1);

      for (let i = 0; i < span; i++) {
        const bank = banks[i] || {};
        const address = addresses[i] || {};
        const gst = gsts[i] || {};

        const state = await GetState(address.country);
        const city = await GetCity(address.country, address.state);
        worksheet.addRow({
          srNo: i === 0 ? serialNo : "",
          customerType: i === 0 ? client.customerType : "",
          companyName: i === 0 ? client.companyName : "",
          vendorType: i === 0 ? client.vendorType : "",

          contactPerson: i === 0 ? client.contPerNam : "",

          contactEmail: i === 0 ? client.contPerEmail : "",

          contactPhone: i === 0 ? client.contPhoneNo : "",
          mobileNum: i === 0 ? client.mobileNum : "",

          taxType: i === 0 ? getDropdownLabel(client.taxRegTyp, "taxType") : "",

          taxPreference: i === 0 ? client.taxPref : "",

          openingBalance: i === 0 ? client.opBl : "",
          pnNo: i === 0 ? client.pnNo : "",
          gst: gst.taxId || "",
          pos: gst.pos || "",

          addr1: address.houseNo || "",
          addr2: address.area || "",
          addrCountry:
            country.find((c) => c.id === address.country)?.name || "",
          addrState: state.find((s) => s.id === address.state)?.name || "",
          addrCity: city.find((c) => c.id === address.city)?.name || "",
          addrPin: address.pinCode || "",
          addrType: address.addType,
          attention: address.attention || "",
          addr_phone: address.phone || "",
          addr_email: address.email || "",

          holder: bank.hldNam || "",
          bank: bank.bankNam || "",
          account: bank.bankAccNum || "",
          accountType: getDropdownLabel(bank.accTyp, "accountType"),

          ifsc: bank.ifsc || "",
          branch: bank.brchNam || "",
          swift: bank.swift || "",
          bnk_city: bank.city || "",
          bnk_state: bank.state || "",
        });
      }

      if (span > 1) {
        const start = currentRow;
        const end = currentRow + span - 1;

        mergeColumns.forEach((col) => {
          worksheet.mergeCells(`${col}${start}:${col}${end}`);

          worksheet.getCell(`${col}${start}`).alignment = {
            vertical: "middle",
            horizontal: "left",
            wrapText: true,
          };
        });
      }

      currentRow += span;

      worksheet.addRow({});

      worksheet.mergeCells(`A${currentRow}:AG${currentRow}`);
      currentRow++;
      serialNo++
    }

    // ---------------- Data Styling ----------------

    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber === 1) return;

      row.eachCell((cell, colNumber) => {
        const columnLetter = worksheet.getColumn(colNumber).letter;

        // Alignment
        cell.alignment = {
          vertical: "middle",
          horizontal: numericColumns.includes(columnLetter) ? "right" : "left",
          wrapText: true,
        };

        // Treat all string values as text
        if (typeof cell.value === "string") {
          cell.numFmt = "@";
        }

        cell.font = {
          size: 10,
        };
      });
    });


    // Download

    const buffer = await workbook.xlsx.writeBuffer();
    downloadBufferAsExcelFile(buffer);
  };

  function downloadBufferAsExcelFile(buffer) {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    a.download = `vendor_${moment().format("DD-MMM-YYYY")}.xlsx`;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  async function handleExport() {
    const data = await fetchAsyncExportVendor();
    if (data?.data) {
      // exportClientExcelDynamicColumns(data?.data);
      downloadClientExportGrouped(data?.data);
    }
  }

  useEffect(() => {
    if (vendorList && vendorList.length > 0) {
      const tableData = vendorList.map((data, index) => {
        return {
          _id: data._id,
          no: index + 1,
          companyName: (
            <span style={{ cursor: "pointer", color: "blue" }}>
              {data?.name}
            </span>
          ),
          contactPerson: data?.cptn,
          email: data?.mail,
          isVendor: (
            <span className={data?.isV ? "checkmark" : "crossmark"}></span>
          ),
          isConsultant: (
            <span className={data?.isC ? "checkmark" : "crossmark"}></span>
          ),
          bankAccount: (
            <div class="position-relative">
              <RiBankCardFill size={25} />
              <span className="position-absolute top-0 start-100 translate-middle badge  bg-primary text-white">
                {data?.bnkDtl && data?.bnkDtl?.length
                  ? data?.bnkDtl?.length
                  : 0}
              </span>
            </div>
          ),

          panNumber: data?.pnNo,
          action: (
            <div className="d-flex">
              <MdModeEdit
                className="me-2"
                color="blue"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  handleEditClick(e, data._id);
                }}
              />
              <AiFillEye
                className="me-2"
                color="#000D55"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  handleRowClick(e, data?._id);
                }}
              />
              {role === "Admin" ? (
                <AiFillDelete
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                  size={16}
                  onClick={(e) => {
                    e.preventDefault();
                    const confirmationMessage = orgJson.confirm.deleteVendor;
                    const title = confirmationMessage.replace(
                      "{companyName}",
                      data?.name,
                    );
                    ConfirmationDialog({
                      title: title,
                      text: orgJson.text.undone,
                      icon: "warning",
                      confirmButtonText: "delete",
                      cancelButtonText: "Cancel",
                      onConfirm: () => {
                        deleteVendor(data);
                      },
                    });
                  }}
                />
              ) : (
                "No Access"
              )}
            </div>
          ),
        };
      });
      setVendorListData(tableData);
    } else {
      setVendorListData([]);
    }
  }, [vendorList]);

  const navigate = useNavigate();

  const handleRowClick = (e, _id) => {
    e.stopPropagation();
    const data = vendorList.filter((item) => item?._id === _id);
    setVendorEditData(data[0]);
    navigate(`/vendor/${_id}`);
  };

  const handleEditClick = (e, _id) => {
    e.stopPropagation();
    const data = vendorList.filter((item) => item?._id === _id);
    setOpenEditModal(true);
    setVendorEditData(data[0]);
    handleOpenVendorModal();
  };

  useEffect(() => {
    setLoading(true);
    dispatch(fetchAsyncGetVendor())
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, []);
  const textColor = useColorModeValue("secondaryGray.900", "white");

  if (loading) {
    return <SpinnerLoader />;
  }
  return (
    <>
      <Box display="flex" className="mx-0" justifyContent="space-between">
        <Box display="flex">
          <Text
            color={textColor}
            fontSize="22px"
            fontWeight="700"
            lineHeight="100%"
            mt={5}
            mx={2}
          >
            Vendors
          </Text>
        </Box>
        <Box display="flex" mt={2} className="add-new-btn gap-2">
          <Box
            display="flex"
            alignItems="center"
            className="new-btn"
            onClick={handleExport}
          >
            <BiExport size={12} className="new-plus-icon text-white fs-4" />{" "}
            Export
          </Box>

          <Box
            display="flex"
            alignItems="center"
            className="new-btn"
            onClick={handleOpenVendorModal}
          >
            <FaPlus size={12} className="new-plus-icon" /> New
          </Box>
        </Box>
      </Box>
      <Box pt={{ base: "40px", md: "10px", xl: "10px" }}>
        <ColumnTable
          columnsData={vendorDataColumns}
          tableData={vendorListData}
          type={"Vendors"}
          role={role}
          expenseType="vendors"
          openInfoModal={handleRowClick}
        />
      </Box>
      {openVendorModal && (
        <VendorsAddNew
          openModal={openVendorModal}
          closeModal={handleCloseVendorModal}
          isEdit={openEditModal}
          editData={vendorEditData}
          role={role}
          refreshEditData={handlerRefreshData}
        />
      )}
    </>
  );
};

export default EmbrillVendor;
